import { render, staticRenderFns } from "./DeductiblesQuotator.vue?vue&type=template&id=18ab078f&scoped=true&"
import script from "./DeductiblesQuotator.vue?vue&type=script&lang=js&"
export * from "./DeductiblesQuotator.vue?vue&type=script&lang=js&"
import style0 from "./DeductiblesQuotator.vue?vue&type=style&index=0&id=18ab078f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab078f",
  null
  
)

export default component.exports